import { InvoiceFile } from './invoice-file.model';

export class InvoiceHeader {
  referenceNumber: string;
  documentType: string;
  dates: {
    operationDate: string;
    invoiceDate?: string;
  };
  files: InvoiceFile;
  customerContact: string;
  customerEmail: string;
  description?: string;
  comments: string;
  incoterm?: string;

  constructor(values= {}) {
    Object.assign(this, values);
    this.files = this.files ? new InvoiceFile(this.files) : new InvoiceFile();
  }
}
